import Main from './Main'
import Lista from './components/TipoGrvLista'
import Novo from './components/NovoTipoGrv'

export default [
  {
    path: 'tipo-grv',
    name: 'policiacivil.processo.tipo-grv',
    component: Main,
    redirect: { name: 'policiacivil.processo.tipo-grv.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.tipo-grv.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.tipo-grv.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.tipo-grv.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/tipo-grv/routes.js